// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".otwPu6ErZHWcHtyWedbW {\n\n}\n", "",{"version":3,"sources":["webpack://./src/App/Pages/Home/Layout/styles.css"],"names":[],"mappings":"AAAA;;AAEA","sourcesContent":[":local(.container) {\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "otwPu6ErZHWcHtyWedbW"
};
export default ___CSS_LOADER_EXPORT___;
